import React, { useEffect, useRef, useState } from 'react';
import { Button, Form, Input, InputNumber, message, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { ApiName } from "../APIname";
import axios from "axios";

function ModalGrantManaviy(props) {
    const [fulInfo] = useState(JSON.parse(localStorage.getItem("myCat")));
    const inputRef = useRef(null);
    const formRef = useRef(null);
    const [form] = Form.useForm();
    const [fileID, setFileID] = useState()

    useEffect(() => {
        setTimeout(() => {
            inputRef.current?.focus();
        }, 100); // biroz kechiktirish bilan
    }, [props?.handleCancel, props?.onSuccess]);

    function handleOk() {
        const ball = parseFloat(form.getFieldValue('Ball'));
        if (!ball || isNaN(ball)) {
            message.error("Ball raqam sifatida kiritilishi shart");
            return;
        }

        axios.put(`${ApiName}/grant/api/mark-rating`, {
            applicationId: props?.user?.id,
            departmentRating: ball
        }, {
            headers: { Authorization: `Bearer ${fulInfo?.accessToken}`, "ngrok-skip-browser-warning": "true" }
        }).then(res => {
            if (props?.onSuccess) props.onSuccess();
            props.handleCancel()
            message.success("Ball saqlandi!");
        }).catch(err => {
            console.log(err)
            message.error(`${err?.response?.data?.message}`)
        });
    }

    // function handleOk() {
    //     axios.put(`${ApiName}/api/application/update-department-rating`, {
    //         applicationId: props?.user?.id,
    //         departmentRating: Number(form.getFieldValue('Ball')),
    //     }, {
    //         headers: {
    //             "Authorization": `Bearer ${fulInfo.accessToken}`
    //         }
    //     }).then((response) => {
    //         console.log(response)
    //     }).catch((error) => {
    //         console.log(error)
    //     })
    //     // Number(form.getFieldValue('Ball'))
    // }


    const propsss = {
        name: 'file',
        action: `${ApiName}/grant/api/attach/upload`,
        headers: {
            authorization: `Bearer ${fulInfo?.accessToken}`,
        },
        maxCount: 1,

        onChange(info) {
            if (info?.file?.status === 'removed') {
                // const result = ariza?.files?.filter((idAll) => idAll?.id !== info?.file?.response?.id);
                // setAriza({...ariza, files: result})
                // axios.delete(`${ApiName}/api/v1/attach/${info?.file?.response?.id}`, {
                //     headers: {"Authorization": `Bearer ${fulInfo?.accessToken}`}
                // }).then((res) => {
                //     message.success("File o'chirildi")
                // }).catch((error) => {
                //     message.error(`${info.file.name} file delete failed.`);
                // })
            } else if (info?.file?.status === "done") {
                axios.post(`${ApiName}/grant/api/application-file/save`, {
                    applicationId: props?.user?.id,
                    fileId: info?.file?.response?.id,
                    // orderNumber: Number(form.getFieldValue('Ball')),
                }, {
                    headers: { "Authorization": `Bearer ${fulInfo.accessToken}` }
                }).then((response) => {
                    if (response?.data?.code === 400) {
                        message.error("Bu arizaga allaqachon fayl biriktirilgan!");
                    } else {
                        message.success("File yuklandi");
                    }
                    // `${response?.data?.message}`
                }).catch((error) => {
                    // message.error(`${error?.data?.message}`)
                    console.log(error)

                })
                console.log(info?.file?.response)
                setFileID(info?.file?.response?.id);
                // ariza?.files.push({
                //         fileId: info?.file?.response?.id,
                //     }
                // )
                // message.success(`${info?.file?.name} File uploaded successfully`);
            } else if (info?.file?.status === 'error') {
                message.error(`${info?.file?.name} File upload failed.`);
            }
        },

    };
    return (
        <div className='border-top border-success'>
            <Form
                form={form} layout="vertical" ref={formRef} colon={false}
                onFinish={handleOk}
            >
                <Form.Item rules={[{ required: true, message: 'Malumot kiritilishi shart !!!' }]} label="Asoslovchi hujjat yuklansin" name='file'>
                    <Upload name='file' {...propsss} accept="application/pdf">
                        <Button icon={<UploadOutlined />}>PDF File yuklash</Button>
                    </Upload>
                </Form.Item>
                <Form.Item label="Talabaga berilgan ball" name="Ball" required={true}
                    rules={[{ required: true, message: 'Malumot kiritilishi shart !!!' }]}>
                    <InputNumber
                        min={0}
                        max={100}
                        step={0.1} 
                        placeholder="1-100 raqamdan iborat bo'lishi kerak"
                        style={{ width: '100%' }}
                    />
                </Form.Item>
                <Form.Item>
                    <button className="btn btn-primary">
                        Yuborish
                    </button>
                </Form.Item>
            </Form>
        </div>
    );
}

export default ModalGrantManaviy;